"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFailureAlertWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../commonFunctions");
var portal_core_1 = require("@ferry/portal-core");
var PaymentFailureAlertWidget = /** @class */ (function (_super) {
    __extends(PaymentFailureAlertWidget, _super);
    function PaymentFailureAlertWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.title = _this.getSetting("title", "Oops! Something went wrong...");
        _this.responseCodeTranslations = _this.getSetting("responseCodeTranslations");
        if (!_this.responseCodeTranslations || _this.responseCodeTranslations.length === 0) {
            throw new Error("".concat(_this.props.question.type, " widget missing 'responseCodeTranslations' setting"));
        }
        _this.state = {
            closed: false,
            scrollPerformed: false
        };
        _this.getErrorMessage = _this.getErrorMessage.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.logError = _this.logError.bind(_this);
        return _this;
    }
    PaymentFailureAlertWidget.prototype.componentDidUpdate = function () {
        if (!this.state.scrollPerformed) {
            var element = document.getElementById("payment-failure-alert-widget");
            element && element.scrollIntoView({ behavior: 'smooth' });
            this.setState({ scrollPerformed: true });
        }
    };
    PaymentFailureAlertWidget.prototype.componentDidCatch = function (error) {
        this.logError(error);
    };
    PaymentFailureAlertWidget.prototype.render = function () {
        if (!this.state.closed) {
            var paymentDetails = this.props.interaction.paymentDetails;
            var errorMessage = this.getErrorMessage();
            if (errorMessage && !paymentDetails.cancelled) {
                return ((0, jsx_runtime_1.jsxs)("div", { id: "payment-failure-alert-widget", className: "page-validation journey-validation-summary", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top", children: this.title }), (0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-bottom", children: errorMessage })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-validation-close", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn page-validation-close-button", onClick: this.handleClose }) })] }));
            }
        }
        return (0, jsx_runtime_1.jsx)(React.Fragment, {});
    };
    PaymentFailureAlertWidget.prototype.getErrorMessage = function () {
        var _a;
        var paymentDetails = this.props.interaction.paymentDetails;
        var brandName = this.props.interaction.brandName ?
            (0, portal_core_1.getPrettifiedInteractionBrandName)(this.props.interaction.brandName) :
            portal_core_1.resourcesHelper.THEME_NAME;
        if (paymentDetails) {
            var error = this.responseCodeTranslations.find(function (translation) { return translation.responseCodes.some(function (code) { return code === paymentDetails.responseCode; }); });
            var errorMessage = (_a = error === null || error === void 0 ? void 0 : error.errorMessage) === null || _a === void 0 ? void 0 : _a.replace(/{brandName}/g, (0, commonFunctions_1.capitalize)(brandName));
            if (error && errorMessage) {
                this.logError(new Error(errorMessage));
                return errorMessage;
            }
            if (paymentDetails.failed) {
                return "Payment failed";
            }
            if (paymentDetails.detailsValid === false) {
                return "Payment details are invalid.";
            }
        }
        return undefined;
    };
    PaymentFailureAlertWidget.prototype.handleClose = function () {
        this.setState({
            closed: true
        });
    };
    PaymentFailureAlertWidget.prototype.logError = function (error) {
        if (this.props.interaction) {
            this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
                level: "ERROR",
                message: "Payments exception: ".concat(error && error.message ? error.message : "", "\n                        Interaction id: ").concat(this.props.interaction._id || "-", "\n                        Stack: ").concat(error && error.stack || "-")
            }, false).subscribe();
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], PaymentFailureAlertWidget.prototype, "journeyRuntimeService", void 0);
    return PaymentFailureAlertWidget;
}(plugin_journey_1.WidgetBase));
exports.PaymentFailureAlertWidget = PaymentFailureAlertWidget;
//# sourceMappingURL=PaymentFailureAlertWidget.js.map